import React from "react";
import { Form, Input, Row, Col } from "antd";

const TabletForm = ({ form }) => {
  return (
    <Form form={form} layout="vertical">
      <Row gutter={16}>
        <Col span={24}>
          <Form.Item
            name="tablet_id"
            label="Tablet ID"
            rules={[{ required: true, message: "Please enter the tablet ID!" }]}
          >
            <Input />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={16}>
        <Col span={24}>
          <Form.Item
            name="name"
            label="Name"
            rules={[
              { required: true, message: "Please enter the tablet name!" },
            ]}
          >
            <Input />
          </Form.Item>
        </Col>
      </Row>
    </Form>
  );
};

export default TabletForm;
